import { pathOr } from 'ramda';
import { useSportsbookStore } from '../../store';

export const selectTournamentsIds = (serviceId) =>
  pathOr([], ['tournaments', serviceId, 'ids']);

export const useTournamentsIds = (serviceId) =>
  useSportsbookStore(selectTournamentsIds(serviceId));
